import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyCharacteristicsDto, PropertyCreationStep, PropertyDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyMissingInfoUtils } from '../../../../utils/property-missing-info.utils';
import { EtxePropertySectionReminderComponent } from '../../../property-section-reminder/property-section-reminder.component';
import { PropertyCharacteristicsDisplayComponent } from '../display/characteristics-display.component';
import { PropertyCharacteristicsFormComponent } from '../form/characteristics-form.component';

@Component({
  selector: 'etxe-property-characteristics-edit',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyCharacteristicsDisplayComponent,
    PropertyCharacteristicsFormComponent,
    EtxePropertySectionReminderComponent,
  ],
  templateUrl: './characteristics-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyCharacteristicsEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);

  missingItems = computed(() =>
    PropertyMissingInfoUtils.getMissingItemsByStep(this.property(), PropertyCreationStep.CHARACTERISTICS),
  );

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyCharacteristicsDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyCharacteristicsDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
